export class Schema {
    constructor(columns) {
        this._columns = columns || new Array();
    }
    get columns() {
        return this._columns;
    }
    addColumn(column) {
        this.columns.push(column);
    }
    getColumn(name) {
        return this.columns.find((c) => c.name === name);
    }
}
